import {Controller} from "stimulus"
import * as basicScroll from "basicscroll"

export default class extends Controller {

    static targets = [
        "progressReference"
    ]

    initialize() {

        console.log("global !")

        if ( this.hasProgressReferenceTarget ) {

            this.initHeaderProgressBar()

        }

    }

    initHeaderProgressBar(){

        document.querySelector(".header").classList.add("has-progress-bar")

        const instance = basicScroll.create({
            elem: this.progressReferenceTarget,
            from: "top-top", // doc, el
            to: "bottom-bottom",
            direct: false,
            props: {
                '--scale-reading-progress-bar': {
                    from: 0,
                    to: 1,
                    //timing: 'expoIn'
                }
            }
        })

        instance.start()

    }


}